import numeral from 'numeral';

// TODO: Advanced validation (regex?)
const isNumeralValue = input => {
  return !Number.isNaN(+input) || input.trim().startsWith('$') || input.trim().endsWith('%');
};
const isDateValue = input => {
  return !Number.isNaN(Date.parse(input));
};

export const sortDescending = (a, b) => {
  if (a === b) return 0;
  if (!a) return 1;
  if (!b) return -1;

  if (isNumeralValue(a) && isNumeralValue(b)) {
    return numeral(a).value() < numeral(b).value() ? 1 : -1;
  }
  if (isDateValue(a) && isDateValue(b)) {
    return Date.parse(a) < Date.parse(b) ? 1 : -1;
  }

  return a < b ? 1 : -1;
};

export const sortAscending = (a, b) => {
  if (a === b) return 0;
  if (!a) return 1;
  if (!b) return -1;

  if (isNumeralValue(a) && isNumeralValue(b)) {
    return numeral(a).value() < numeral(b).value() ? -1 : 1;
  }
  if (isDateValue(a) && isDateValue(b)) {
    return Date.parse(a) < Date.parse(b) ? -1 : 1;
  }

  return a < b ? -1 : 1;
};
